import React from "react"
import styled from "styled-components"
import colors from "../../styles/colors"
import fonts from "../../styles/fonts"
import breakpoints from "../../styles/breakpoints"

const Sticker = styled.div`
  z-index: 500;
  position: absolute;
  top: -380px;
  left: 20px;
  ${fonts.americana};
  font-size: 10px;
  font-weight: 400;
  line-height: 12px;
  text-align: center;
  background: transparent;
  height: 24px;
  width: 94px;
  margin: 0;

  p {
    width: 100%;
    height: 100%;
    background: ${colors.white};
    color: ${colors.trueBlack};
    padding: 5px;
    border-radius: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid ${colors.trueBlack};
  }

  @media (min-width: ${breakpoints.md}) {
    z-index: 1;
    margin: 0 0 4px auto;
    position: relative;
    font-size: 14px;
    line-height: 16px;
    height: 36px;
    width: 132px;
    top: unset;
    left: unset;
  }
`

const DiscountSticker = ({ children }) => {
  return (
    <Sticker>
      <p>-{children}%</p>
    </Sticker>
  )
}

export default DiscountSticker;
